import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { MatchCard } from "@/components/MatchCard";
import { FullSpinner, Empty } from "@/components/States";

export default function Shortlist() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/shortlist").then(({ data }) => setData(data)).catch(() => setData({ results: [] })); }, []);
  if (!data) return <FullSpinner />;
  return (
    <div className="space-y-5" data-testid="shortlist-page">
      <h1 className="font-serif text-3xl font-bold text-[#58111A]">Your Shortlist</h1>
      {data.results.length === 0 ? (
        <Empty icon={Star} title="No shortlisted profiles" message="Tap the star on any profile to save it here for later." action={<a href="/app/matches" className="btn-primary">Explore Matches</a>} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{data.results.map((p) => <MatchCard key={p.user_id} p={p} />)}</div>
      )}
    </div>
  );
}
